import $ from 'jquery';
import 'slick-carousel'

export default {
  init() {
    // console.log('common');
  },
  finalize() {
    Testimonials.init();
  },
};

var Testimonials = ( () =>  {
  var self = {};

  self.init = () => {
    console.log("Init testimonials");

    $("#testimonials_slick").slick({
      slidesToShow: 1,
      centerMode: true,
      arrows:false,
      dots: true,
      centerPadding: 0,
      autoplay: true,
      autoplaySpeed: 2000

    });
  };

  return self;
})();